import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LOCALES, resolveSupportedLocale, pickFromNavigatorLanguageList } from '@/lib/i18nLocale';

/** 배포 후 CDN/브라우저가 옛 번역 JSON 을 쓰지 않도록 빌드 버전을 쿼리로 붙인다 (craco.config.js 에서 주입). */
const buildVersion = process.env.REACT_APP_BUILD_VERSION || '';
const versionQuery = buildVersion ? `?v=${encodeURIComponent(buildVersion)}` : '';
const loadPath = `${process.env.PUBLIC_URL || ''}/locales/{{lng}}/{{ns}}.json${versionQuery}`;

i18n
	.use(HttpBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		showSupportNotice: false,
		/* supportedLngs: config/locales SUPPORTED_LOCALE_CODES */
		supportedLngs: [...SUPPORTED_LOCALES],
		/**
		 * - 현재 UI 언어 JSON에 키/번역이 없으면 → en 리소스만 사용(미지원 언어/부분 누락 대응).
		 * - 브라우저/저장 언어는 `i18nLocale`에서 지원 코드로만 쓰고, 미지원이면 en.
		 */
		fallbackLng: 'en',
		/** 빈 문자열/null 값이면 누락으로 보고 en 폴백 */
		returnEmptyString: false,
		returnNull: false,
		load: 'languageOnly',
		partialBundledLanguages: true,
		defaultNS: 'common',
	ns: [
		'common',
		'menu',
		'footer',
		'auth',
		'validation',
		'dashboard',
		'class',
		'landing',
		'scenario',
		'order',
		'product',
		'admin',
		'users',
		'radiation',
	],
		backend: {
			loadPath,
		},
		detection: {
			order: ['localStorage', 'navigator'],
			caches: ['localStorage'],
			lookupLocalStorage: 'i18nextLng',
		},
		interpolation: {
			escapeValue: false,
		},
	react: {
		useSuspense: true,
	},
	});

const I18N_STORAGE = 'i18nextLng';

const onInitialized = (): void => {
	i18n.off('initialized', onInitialized);
	const hasStored = typeof localStorage !== 'undefined' && Boolean((localStorage.getItem(I18N_STORAGE) || '').trim());
	/** 저장 없을 때: navigator 언어 목록에서 지원하는 첫 언어, 아니면 en( pickFromNavigatorLanguageList ) */
	const next = hasStored ? resolveSupportedLocale(i18n.language) : pickFromNavigatorLanguageList();
	if (next !== i18n.language) {
		void i18n.changeLanguage(next);
	}
};
i18n.on('initialized', onInitialized);

export default i18n;
